module.exports = __webpack_public_path__ + "static/media/funitygame3.bf8aae7b.png";